import { Home, Building2, Warehouse, Package, Truck, Piano, Container } from "lucide-react";

const services = [
  {
    icon: Home,
    title: "Local Moves",
    desc: "Block-to-block or city-to-city across Kentucky. Hourly crews, fully equipped truck, 2-hour minimum.",
    tag: "01",
    badge: "$150/hr · 2 movers",
  },
  {
    icon: Truck,
    title: "Regional Moves",
    desc: "KY · IN · OH · WV — one crew loads, drives & delivers across our four-state region.",
    tag: "02",
  },
  {
    icon: Container,
    title: "Freight & Containers",
    desc: "We load AND unload PODS, U-Box, freight trailers, and shipping containers. 2-hour minimum, labor-only hourly rate.",
    tag: "03",
    badge: "$150/hr · 2 movers",
  },
  {
    icon: Warehouse,
    title: "Storage Solutions",
    desc: "Climate-controlled vault & container storage. By the month or long-term.",
    tag: "04",
  },
  {
    icon: Package,
    title: "Packing & Unpacking",
    desc: "We bring the boxes, paper, blankets. Pack everything or just the breakables.",
    tag: "05",
  },
  {
    icon: Building2,
    title: "Commercial Moves",
    desc: "Offices, warehouses, retail. After-hours scheduling. Zero downtime guaranteed.",
    tag: "06",
  },
  {
    icon: Piano,
    title: "Specialty Items",
    desc: "Pianos, gun safes, antiques, art. Trained crew, proper rigging, real care.",
    tag: "07",
  },
];

export default function Services() {
  return (
    <section id="services" className="py-24 lg:py-32" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="overline">What We Do</div>
            <h2 className="mt-3 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight max-w-2xl leading-[0.95]">
              Seven ways we move you forward.
            </h2>
          </div>
          <p className="max-w-md text-[#5C635F] leading-relaxed">
            One crew. One number to call. Every service you'd ever need on moving day —
            and a lot of services you didn't know you needed.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 border-l border-t border-[#DDD8C9]">
          {services.map((s) => (
            <div
              key={s.title}
              className="group border-r border-b border-[#DDD8C9] p-8 bg-[#F5F3EC] hover:bg-white transition-colors duration-200"
              data-testid={`service-${s.tag}`}
            >
              <div className="flex items-start justify-between">
                <div className="w-12 h-12 bg-[#223932] flex items-center justify-center group-hover:bg-[#5BB239] transition-colors duration-200">
                  <s.icon className="w-6 h-6 text-white" strokeWidth={2} />
                </div>
                <span className="font-mono-label text-[10px] text-[#5C635F]">{s.tag} / 07</span>
              </div>
              <h3 className="mt-8 font-display font-bold text-2xl">{s.title}</h3>
              <p className="mt-3 text-sm text-[#5C635F] leading-relaxed">{s.desc}</p>
              {s.badge && (
                <div className="mt-4 inline-block bg-[#223932] text-white font-mono-label text-[10px] px-2.5 py-1">
                  {s.badge}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
